export const meta = {
  title: "Nachhaltiger Luxus: Verantwortungsbewusstes Reisen in den Alpen",
  description: "Kann Luxus umweltfreundlich sein? Entdecken Sie, wie das Beatenberg Resort & Spa die alpine Umwelt schützt.",
  date: "2024-03-22",
  image: "/images/local_attractions/beatenberg_trail.main-1000h.webp",
  author: "Beatenberg Green Team",
  category: "Sustainability",
  keywords: ["nachhaltiges hotel schweiz", "öko reisen alpen", "verantwortungsvoller tourismus"]
}

# Nachhaltiger Luxus: Verantwortungsbewusstes Reisen in den Alpen

Die Schweizer Alpen sind nicht nur eine Kulisse für unser Resort; sie sind unsere Heimat und unser Erbe.

*Inhalt wird bald erweitert...*
